function toHex(bytes: Uint8Array): string {
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export function generateTraceId(): string {
  return toHex(crypto.getRandomValues(new Uint8Array(16)));
}

export function generateSpanId(): string {
  return toHex(crypto.getRandomValues(new Uint8Array(8)));
}

export function generateTraceparent(): string {
  return `00-${generateTraceId()}-${generateSpanId()}-01`;
}
